import { Head, useForm, Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Checkbox } from "@/components/ui/checkbox"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

interface User {
  id: number
  username: string
  admin: boolean
}

interface EditProps {
  user: User
}

export default function Edit({ user }: EditProps) {
  const { data, setData, put, processing, errors } = useForm({
    username: user.username,
    password: "",
    password_confirmation: "",
    admin: user.admin,
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/admin/users/${user.id}`)
  }

  return (
    <div className="container mx-auto py-8 max-w-md">
      <Head title="Modifier l'utilisateur" />
      <Card>
        <CardHeader>
          <CardTitle>Modifier l'utilisateur</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username">Nom d'utilisateur</Label>
              <Input
                id="username"
                value={data.username}
                onChange={(e) => setData("username", e.target.value)}
                required
              />
              {errors.username && (
                <p className="text-sm text-destructive">{errors.username}</p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Mot de passe (laisser vide pour ne pas changer)</Label>
              <Input
                id="password"
                type="password"
                value={data.password}
                onChange={(e) => setData("password", e.target.value)}
              />
              {errors.password && (
                <p className="text-sm text-destructive">{errors.password}</p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="password_confirmation">Confirmer le mot de passe</Label>
              <Input
                id="password_confirmation"
                type="password"
                value={data.password_confirmation}
                onChange={(e) => setData("password_confirmation", e.target.value)}
              />
              {errors.password_confirmation && (
                <p className="text-sm text-destructive">
                  {errors.password_confirmation}
                </p>
              )}
            </div>

            <div className="flex items-center space-x-2">
              <Checkbox
                id="admin"
                checked={data.admin}
                onCheckedChange={(checked) => setData("admin", checked as boolean)}
              />
              <Label htmlFor="admin">Administrateur</Label>
            </div>

            <div className="flex justify-end space-x-4">
              <Button variant="outline" asChild>
                <Link href="/admin/users">Annuler</Link>
              </Button>
              <Button type="submit" disabled={processing}>
                Enregistrer
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
